import React from 'react';

const AiAnalysis = ({ width = 16, height = 16, className, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      role='presentation'
      aria-hidden='true'
      {...rest}
    >
      <path
        d='M9.80664 4.91016C9.95047 4.2794 10.851 4.27181 10.9951 4.90234L11.1875 5.75C11.5493 7.33684 12.7891 8.57586 14.376 8.9375L15.4834 9.19043C16.1727 9.34785 16.1727 10.3299 15.4834 10.4873L15.166 10.5596C13.0948 11.0316 11.475 12.6446 10.9941 14.7139L10.8281 15.4277C10.7232 15.8793 10.0769 15.8654 9.97168 15.4141C9.39234 12.9206 7.47798 10.9179 5.00488 10.2568C4.57675 10.1423 4.57666 9.53438 5.00488 9.41992L5.62793 9.25391C7.71619 8.69573 9.32613 7.01764 9.80664 4.91016ZM1.67285 6.75293C1.71968 6.54698 2.01357 6.54418 2.06055 6.75L2.11914 7.00684C2.23882 7.53317 2.65913 7.93863 3.18945 8.03906L3.47363 8.09277C3.70545 8.13684 3.71871 8.46369 3.49121 8.52637L3.39844 8.55176C2.73214 8.73468 2.22058 9.2696 2.06738 9.94336L2.00781 10.2061C1.97352 10.3551 1.76085 10.3551 1.72656 10.2061L1.71973 10.1729C1.53443 9.35846 0.913173 8.71334 0.106445 8.49707C-0.0326406 8.45979 -0.0326406 8.26287 0.106445 8.22559L0.310547 8.1709C0.991533 7.98837 1.51642 7.44036 1.67285 6.75293ZM4.44141 0.257812C4.52465 -0.0851971 5.01254 -0.0862381 5.0957 0.256836L5.19922 0.683594C5.41602 1.58031 6.14248 2.26417 7.05078 2.42578L7.53223 2.51074C7.9322 2.5819 7.95389 3.14841 7.56055 3.25L7.40332 3.29004C6.26618 3.58373 5.38341 4.48052 5.10742 5.62207L5.00488 6.04785C4.94506 6.29541 4.59132 6.29129 4.53125 6.04395C4.19457 4.65062 3.11154 3.54792 1.72168 3.19727C1.47869 3.13598 1.47869 2.79078 1.72168 2.72949L2.08691 2.6377C3.25218 2.34367 4.15913 1.426 4.44141 0.257812Z'
        fill='url(#paint0_linear_5409_9196)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_5409_9196'
          x1='-3.4317'
          y1='10.396'
          x2='20.4537'
          y2='10.9464'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#7F6AFF' />
          <stop offset='1' stop-color='#FE7FE2' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AiAnalysis;
